  import { jsx as _jsx, jsxs as _jsxs } from "@fluentui/react-jsx-runtime/jsx-runtime";
import { assertSlots } from '@fluentui/react-utilities';
import { Transition } from 'react-transition-group';
import { ToastContainerContextProvider } from '../../contexts/toastContainerContext';
/**
 * Render the final JSX of ToastContainer
 */ export const renderToastContainer_unstable = (state, contextValues)=>{
    const { onTransitionEntering, visible, transitionTimeout, remove, nodeRef, updateId } = state;
    assertSlots(state);
    return /*#__PURE__*/ _jsx(Transition, {
        in: visible,
        appear: true,
        unmountOnExit: true,
        timeout: transitionTimeout,
        onExited: remove,
        onEntering: onTransitionEntering,
        nodeRef: nodeRef,
        children: /*#__PURE__*/ _jsxs(ToastContainerContextProvider, {
            value: contextValues.toast,
            children: [
                /*#__PURE__*/ _jsx(state.root, {}),
                /*#__PURE__*/ _jsx(state.timer, {}, updateId)
            ]
        })
    });
};
